import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
const Registeration = (registration) => {
    registration.EventId = "043B4CDD-AB95-4A50-78D7-08DD54A6ADA1";
    return vdkHappinessPortalApi.post(`event/event-registration`, registration);
};
const getAllEventsWithDates = () => {
    return vdkHappinessPortalApi.get("event/get-all-events-with-dates");
};
const getAllEvents = () => {
    return vdkHappinessPortalApi.get("event/get-all-events");
};
const getExternalInvitationCount = () => {
    return vdkHappinessPortalApi.get("event/get-external-invitation-count");
};
const getByEventId = (id) => {
    return vdkHappinessPortalApi.get(`event/get-by-eventId/${id}`);
};
const getEventPublicAccessInfo = (id) => {
    return vdkHappinessPortalApi.get(`event/${id}/get-event-public-access-info`);
};
const validatePublicPassword = (query) => {
    return vdkHappinessPortalApi.post("event/validate-public-password", query);
};
const validateInitialRegistration = (query) => {
    return vdkHappinessPortalApi.post("event/validate-initial-registration", query);
};
const getEventRegistrationInfo = (query) => {
    return vdkHappinessPortalApi.post("event/get-event-registration-info", query);
};
const verifyUniqueLink = (id, userType) => {
    let url = `event/${id}/link-verification`;
    if (userType) {
        url += `?userType=${encodeURIComponent(userType)}`;
    }
    return vdkHappinessPortalApi.get(url);
};
const EventApi = {
    Registeration,
    getAllEventsWithDates,
    getAllEvents,
    getExternalInvitationCount,
    getByEventId,
    getEventPublicAccessInfo,
    validatePublicPassword,
    validateInitialRegistration,
    getEventRegistrationInfo,
    verifyUniqueLink
};
export default EventApi;
